import React, {useEffect, useState} from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';
import CommonCheckBox from 'common/src/components/CommonCheckBox';

const CommonSelect = ({type, data, onSelect, disable, style}) => {
    const [filterList, setFilterList] = useState(data);

    useEffect(() => {
        setFilterList(data)
    },[data])

    const updateList = (selected, index) => {
        let _updatedList: any = [...filterList]
        if (type === 'check') {
            _updatedList[index].selected = selected;
        }
        else if (type === 'radio') {
            _updatedList.map((item, i) => {
                item.selected = false
                if (i === index && selected !== false)
                    item.selected = true;
            })  
        }
        setFilterList(_updatedList);
        onSelect(_updatedList)
    }

    const renderSelectList = (item, index) => (
        <CommonCheckBox
            index={index}
            text={item.label}
            type={type === 'check'? 'rounded-checkbox' : 'rounded'}
            updateCheckBox={updateList}
            selected={item.selected}
            testID={item.value}
            checkedIcon={type === 'check' ? true : false}
            disable={disable}
        />
    )

    return (
        <View style={[styles.container, style ? style : {}]}>
            <ScrollView>
                {filterList.map((list,i) => {
                    return <View key={i}>{renderSelectList(list, i)}</View>
                })}
            </ScrollView>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        width: '100%'
    }
})

export default CommonSelect;